import MoneyInTheBankScreen from 'features/lineOfCredit/screens/moneyInTheBank/MoneyInTheBankScreen';
import React from 'react';

export default function Page() {
  return <MoneyInTheBankScreen />;
}
